import React from "react";
import Index from "./index";
import FeedbacksTable from "./FeedbacksTable";

const Feedbacks = () => {
    const { allFeedbacks, loading, history, search, setSearch, onDelete } = Index();
    return (
        <FeedbacksTable
            heading="All Feedbacks"
            allFeedbacks={allFeedbacks}
            loading={loading}
            history={history}
            search={search}
            setSearch={setSearch}
            onDelete={onDelete}
        />
    );
};

const comparisonFn = function (prevProps, nextProps) {
    return prevProps.location.pathname === nextProps.location.pathname && prevProps.colorMode === nextProps.colorMode;
};
export default React.memo(Feedbacks, comparisonFn);
